export const UPDATE_TIP = 'UPDATE_TIP';
export const GET_TIP = 'GET_TIP';
export const GET_TIP_SUCCESS = 'GET_TIP_SUCCESS';
export const TIP_ERROR = 'GET_TIP_ERROR';
export const CLEAR_TIP = 'CLEAR_TIP';
export const UPDATE_TIP_DB = "UPDATE_TIP_DB";